import { render, staticRenderFns } from "./UserPopover.vue?vue&type=template&id=a0fcf25c&scoped=true"
import script from "./UserPopover.vue?vue&type=script&lang=js"
export * from "./UserPopover.vue?vue&type=script&lang=js"
import style0 from "./UserPopover.vue?vue&type=style&index=0&id=a0fcf25c&prod&lang=scss"
import style1 from "./UserPopover.vue?vue&type=style&index=1&id=a0fcf25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fcf25c",
  null
  
)

export default component.exports